// extracted by mini-css-extract-plugin
export default {"wheelSections":"Sections_wheelSections__Ffe6P"};